import type { OthersNameplates, OwnNameplate } from "../settings.ts";
import { say } from "../../words.ts";

/**
 * The Nameplates choices as Settings offers them (P1.9-T24; ADR-065, "the family is one look away"): other players'
 * plates as First name, Full name, Flag only or Off, and the player's own plate as Off or On, worded by the
 * language files. A choice's value is the text the store keeps for it (`settings.ts`), so the segmented choice, the store
 * and the page's `NameplateSettings` all read one format.
 */

/**
 * One choice: its value and its label.
 */
export interface NameplateChoice<T extends string> {
  readonly value: T;
  readonly label: string;
}

/**
 * Other players' plates, in the order Settings offers them: First name, Full name, Flag only and Off.
 *
 * @returns The choices.
 */
export function othersNameplateChoices(): readonly NameplateChoice<OthersNameplates>[] {
  return [
    { value: "first", label: say("settings.othersNameplateChoices.first") },
    { value: "full", label: say("settings.othersNameplateChoices.full") },
    { value: "flag", label: say("settings.othersNameplateChoices.flag") },
    { value: "off", label: say("settings.othersNameplateChoices.off") },
  ];
}

/**
 * The player's own plate: Off, the default, and On.
 *
 * @returns The choices.
 */
export function ownNameplateChoices(): readonly NameplateChoice<OwnNameplate>[] {
  return [
    { value: "off", label: say("settings.ownNameplateChoices.off") },
    { value: "on", label: say("settings.ownNameplateChoices.on") },
  ];
}
